@if (!isLoading) {
  <div class="login-container relative flex h-full min-h-screen flex-col items-center justify-center overflow-hidden">
    <!-- Logo -->
    <div class="z-10 mb-8">
      <img src="assets/images/logo-white.png" class="login-logo" alt="AMLCare" />
    </div>

    <!-- Auth card -->
    <div class="login-card z-10 rounded-xl bg-white p-8 shadow-lg">
      @switch (status) {
        @case ("login") {
          <div>
            <h2 class="mb-6 text-center text-neutral-700 t-h2">{{ "login.Login" | translate }}</h2>
            @if (checkForLoginStrategy) {
              <form [formGroup]="checkLoginStrategyForm">
                <div class="mb-4">
                  <label class="mb-2 block text-neutral-600 t-body">{{ "login.Email" | translate }}</label>
                  <ui-input
                    formControlName="email"
                    [placeHolder]="'login.Enter_Username' | translate"
                    [size]="'large'"
                    [hasError]="!!errorMsg"
                    (input)="removeError($event)"
                    (keydown.enter)="loginStrategyLoading && doLoginStrategy()"
                    data-test-id="emailInput"
                  >
                  </ui-input>
                </div>
                <div class="mt-6">
                  <ui-button
                    class="login-button"
                    [label]="loginStrategyLoading ? ('login.Continue' | translate) : ''"
                    [icon]="loginStrategyLoading ? undefined : 'LoaderCircle'"
                    [iconAnimation]="loginStrategyLoading ? undefined : 'spin'"
                    variant="primary"
                    [fullWidth]="true"
                    [size]="'large'"
                    [disabled]="!isValidEmail || !loginStrategyLoading"
                    (clicked)="doLoginStrategy()"
                    data-test-id="continueButton"
                  >
                  </ui-button>
                </div>
              </form>
            }
            @if (userNamePasswordStrategy) {
              <form [formGroup]="loginForm">
                <div class="mb-4">
                  <label class="mb-2 block text-neutral-600 t-body">{{ "login.Email" | translate }}</label>
                  <ui-input
                    formControlName="email"
                    [placeHolder]="'login.Enter_Username' | translate"
                    [size]="'large'"
                    (input)="removeError($event)"
                    (keydown.enter)="doLogin()"
                  >
                  </ui-input>
                </div>
                <div class="mb-4">
                  <label class="mb-2 block text-neutral-600 t-body">{{ "internal-user.Password" | translate }}</label>
                  <ui-input
                    formControlName="password"
                    [placeHolder]="'login._' | translate"
                    [type]="showPassword ? 'text' : 'password'"
                    [size]="'large'"
                    [hasError]="!!errorMsg"
                    [inputIcon]="showPassword ? 'Eye' : 'EyeOff'"
                    (input)="removeError($event)"
                    (inputIconButtonClick)="showPassword = !showPassword"
                    (keydown.enter)="doLogin()"
                    data-test-id="passwordInput"
                  >
                  </ui-input>
                </div>
                <div class="mt-6">
                  <ui-button
                    class="login-button"
                    [label]="'login.Login' | translate"
                    variant="primary"
                    [fullWidth]="true"
                    [size]="'large'"
                    [disabled]="loginForm.invalid"
                    (clicked)="doLogin()"
                    data-test-id="loginButton"
                  >
                  </ui-button>
                </div>
              </form>
            }
            @switch (errorMsg) {
              @case ("NOT-REGISTERED") {
                <p class="login-error">{{ "login.User_is_Not_Registered" | translate }}</p>
              }
              @case ("BAD-REQUEST") {
                <p class="login-error">{{ "login.Invalid_Email_id" | translate }}</p>
              }
              @case ("WRONG-CREDENTIALS") {
                <p class="login-error">{{ "login.Invalid_User_or_Password" | translate }}</p>
              }
              @case ("DATABASE-ERROR") {
                <p class="login-error">{{ "login.Something_Went_Wrong" | translate }}</p>
              }
              @case (" INTERNAL-SERVER-ERROR") {
                <p class="login-error">{{ "login.Something_Went_Wrong" | translate }}</p>
              }
              @case ("Unauthorized") {
                <p class="login-error">{{ "login.Unauthorized" | translate }}</p>
              }
              @case ("SSO_REQUIRED") {
                <p class="login-error">{{ "login.SSO_REQUIRED" | translate }}</p>
              }
            }
            <div class="mt-4 text-center">
              <a
                class="login-link"
                routerLink="/forgot"
                [queryParams]="{ email: loginForm.controls.email.value }"
                data-test-id="forgotPasswordLink"
              >
                {{ "login.Forgot_Password" | translate }}?
              </a>
            </div>
          </div>
        }

        @case ("forgot") {
          <div>
            <h2 class="mb-6 text-center text-neutral-700 t-h2">{{ "login.Forgot_Password" | translate }}</h2>
            <form [formGroup]="forgotForm">
              <p class="mb-4 text-neutral-600 t-body">{{ "login.Enter_your_email_to_Retrieve_your_account" | translate }}</p>
              <div class="mb-4">
                <label class="mb-2 block text-neutral-600 t-body">{{ "login.Email" | translate }}</label>
                <ui-input
                  formControlName="email"
                  [placeHolder]="'login.Email' | translate"
                  [size]="'large'"
                  [hasError]="!!errorMsg"
                  (input)="removeError($event)"
                  (keydown.enter)="forgot()"
                  data-test-id="forgotPasswordEmailInput"
                >
                </ui-input>
              </div>
            </form>
            <div class="mt-6">
              <ui-button
                class="login-button"
                [label]="'login.Send_Password' | translate"
                variant="primary"
                [fullWidth]="true"
                [size]="'large'"
                [disabled]="forgotForm.invalid"
                (clicked)="forgot()"
                data-test-id="resetPasswordButton"
              >
              </ui-button>
            </div>
            @switch (errorMsg) {
              @case ("NOT-REGISTERED") {
                <p class="login-error">{{ "login.User_is_Not_Registered" | translate }}</p>
              }
              @case ("REQUEST-INVALID") {
                <p class="login-error">{{ "login.Invalid_Email_id" | translate }}</p>
              }
              @case ("DATABASE-ERROR") {
                <p class="login-error">{{ "login.Something_Went_Wrong" | translate }}</p>
              }
              @case ("INTERNAL-SERVER-ERROR") {
                <p class="login-error">{{ "login.Something_Went_Wrong" | translate }}</p>
              }
              @case ("MAILER-ERROR") {
                <p class="login-error">{{ "login.Try_again_after_some_time" | translate }}</p>
              }
            }
            @if (isResetSuccessfully) {
              <div class="reset-success-container">
                <p class="reset-success-message t-body">
                  <span class="font-semibold">{{ "login.Password_rest_sent" | translate }} </span
                  >{{ "login.receive_email_if_you_registered_system" | translate }}
                </p>
              </div>
            }
            <div class="mt-4 text-center">
              <a class="login-link" routerLink="/login">{{ "login.Back_to_login" | translate }}</a>
            </div>
          </div>
        }

        @case ("reset") {
          <div>
            <h2 class="mb-6 text-center text-neutral-700 t-h2">{{ "login.Change_Password" | translate }}</h2>
            <form [formGroup]="passwordForm">
              <div class="mb-4">
                <label class="mb-2 block text-neutral-600 t-body">{{ "login.Enter_New_Password" | translate }}</label>
                <ui-input
                  formControlName="new"
                  [placeHolder]="'login._' | translate"
                  [type]="showResetNewPassword ? 'text' : 'password'"
                  [size]="'large'"
                  [hasError]="!!errorMsg"
                  [inputIcon]="showResetNewPassword ? 'Eye' : 'EyeOff'"
                  (keyup)="checkForPasswordStrength($event)"
                  (keydown.enter)="checkForDisable() || resetPassword()"
                  (inputIconButtonClick)="toggleResetNewPasswordVisibility()"
                >
                </ui-input>
              </div>
              <div class="mb-4">
                <label class="mb-2 block text-neutral-600 t-body">{{ "login.Confirm_Password" | translate }}</label>
                <ui-input
                  formControlName="confirm"
                  [placeHolder]="'login._' | translate"
                  [type]="showResetConfirmPassword ? 'text' : 'password'"
                  [size]="'large'"
                  [inputIcon]="showResetConfirmPassword ? 'Eye' : 'EyeOff'"
                  (keydown.enter)="checkForDisable() || resetPassword()"
                  (inputIconButtonClick)="toggleResetConfirmPasswordVisibility()"
                >
                </ui-input>
              </div>
              <div class="mt-6">
                <ui-button
                  class="login-button"
                  [label]="'login.Submit' | translate"
                  variant="primary"
                  [fullWidth]="true"
                  [size]="'large'"
                  [disabled]="checkForDisable()"
                  (clicked)="resetPassword()"
                >
                </ui-button>
              </div>
            </form>
            @switch (errorMsg) {
              @case ("PASSWORD_WEAK") {
                <p class="login-error">
                  {{
                    "login.Password_must_contain_a_lower_character_a_upper_character_adigit_and_a_special_character_and_length_must_be_between_8_to100_characters"
                      | translate
                  }}
                </p>
              }
              @case ("NOT-REGISTERED") {
                <p class="login-error">{{ "login.User_is_Not_Registered" | translate }}</p>
              }
              @case ("REQUEST-INVALID") {
                <p class="login-error">{{ "login.Invalid_Email_id" | translate }}</p>
              }
              @case ("AUTH_FAIL") {
                <p class="login-error">{{ "login.Something_Went_Wrong" | translate }}</p>
              }
            }
            @if (passwordForm.errors?.passwordMismatch) {
              <p class="login-error">{{ "login.Passwords_do_not_match" | translate }}</p>
            }
          </div>
        }

        @case ("setupTFA") {
          <div>
            <h2 class="mb-6 text-center text-neutral-700 t-h2">{{ "login.Setup_TFA" | translate }}</h2>
            <p class="mb-4 text-neutral-600 t-body">{{ "login.Scan_the_QR_code_in_Google_Authenticator" | translate }}</p>
            <div class="mb-4 flex w-full justify-center">
              <img [src]="TFAData.dataURL" class="tfa-image" alt="" />
            </div>
            <p class="mb-4 text-neutral-600 t-body">{{ "login.Auth_Type_Time_Based_OTP" | translate }}</p>
            <div class="mb-4">
              <ui-input
                [(value)]="authCode"
                [placeHolder]="'login.Enter_the_auth_code' | translate"
                [size]="'large'"
                [hasError]="errorMsg === 'INVALID_CODE'"
                (input)="removeError($event)"
                (keydown.enter)="enableTFA(true)"
              >
              </ui-input>
            </div>
            <div class="mt-6">
              <ui-button
                class="login-button"
                [label]="'login.Enable' | translate"
                variant="primary"
                [fullWidth]="true"
                [size]="'large'"
                [disabled]="authCode.trim() === ''"
                (clicked)="enableTFA(true)"
              >
              </ui-button>
            </div>
            @if (errorMsg === "INVALID_CODE") {
              <p class="login-error">{{ "login.Invalid_Code" | translate }}</p>
            }
          </div>
        }

        @case ("acceptOTP") {
          <div>
            <h2 class="mb-6 text-center text-neutral-700 t-h2">{{ "login.Enter_OTP" | translate }}</h2>
            <div class="mb-4">
              <label class="mb-2 block text-neutral-600 t-body">{{ "login.OTP" | translate }}</label>
              <ui-input
                [(value)]="authCode"
                [placeHolder]="'login.123456' | translate"
                [size]="'large'"
                [hasError]="errorMsg === 'INVALID_CODE'"
                (input)="removeError($event)"
                (keydown.enter)="enableTFA()"
              >
              </ui-input>
            </div>
            <div class="mt-6">
              <ui-button
                class="login-button"
                [label]="'login.Submit' | translate"
                variant="primary"
                [fullWidth]="true"
                [size]="'large'"
                [disabled]="authCode.trim() === ''"
                (clicked)="enableTFA()"
              >
              </ui-button>
            </div>
            @if (errorMsg === "INVALID_CODE") {
              <p class="login-error">{{ "login.Invalid_Code" | translate }}</p>
            }
            <div class="mt-4 text-center">
              <a class="login-link" (click)="status = 'trouble'">Having trouble ?</a>
            </div>
          </div>
        }

        @case ("trouble") {
          <div>
            <h2 class="mb-6 text-center text-neutral-700 t-h2">{{ "login.Having_Trouble" | translate }}</h2>
            <p class="mb-6 break-words text-neutral-600 t-body">
              {{
                "login.To_recover_the_account_please_contact_infoaccountonio_Itmight_take_45_business_days_due_to_security_reasons_to_verifyyour_account"
                  | translate
              }}
            </p>
            <div class="mt-6">
              <ui-button
                class="login-button"
                [label]="'login.Email' | translate"
                variant="primary"
                [fullWidth]="true"
                [size]="'large'"
                (clicked)="sendMailTo()"
              >
              </ui-button>
            </div>
            <div class="mt-4 text-center">
              <a class="login-link" (click)="resetLoginForm()">{{ "login.Back_to_login" | translate }}</a>
            </div>
          </div>
        }
      }
    </div>

    <!-- Ambient glow -->
    <img src="assets/images/login-glow.svg" class="login-glow" alt="" />
  </div>
}

@if (isLoading) {
  <div class="login-container relative flex h-full min-h-screen items-center justify-center overflow-hidden" id="initial_loader">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
